const urlContentHeightWhiteList = ['open-bible']
export const isWhiteListed = (src: string) =>
  urlContentHeightWhiteList.some((whitelistItem) => src.includes(whitelistItem))
